/**
 * @generated SignedSource<<45de030dd89be02a3d93d7e529ea64d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PriceDisplayVariant_displayPrice$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"ItemPrice_displayPrice" | "useItemPriceData_displayPrice">;
  readonly " $fragmentType": "PriceDisplayVariant_displayPrice";
}>;
export type PriceDisplayVariant_displayPrice$key = ReadonlyArray<{
  readonly " $data"?: PriceDisplayVariant_displayPrice$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplayVariant_displayPrice">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PriceDisplayVariant_displayPrice",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemPrice_displayPrice"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemPriceData_displayPrice"
    }
  ],
  "type": "ItemDisplayPriceType",
  "abstractKey": null
};

(node as any).hash = "3b60ac15893685036997b9521951247f";

export default node;
